import React, { FC } from 'react';
import { TAppointment } from '@api/appointments/types';

export const trialsFormatter: FC<TAppointment> = (appointment) => {
  const currentTrials = appointment.trials;

  return <ul>{currentTrials.protocolName}</ul>;
};
